/* GLOBAL CENTER — theme.js */
(function(){
  'use strict';

  // Drawer system
  function openDrawer(id){var d=document.getElementById(id);if(d){d.classList.add('is-open');d.setAttribute('aria-hidden','false');document.body.style.overflow='hidden';}}
  function closeDrawer(d){d.classList.remove('is-open');d.setAttribute('aria-hidden','true');document.body.style.overflow='';}
  document.addEventListener('click',function(e){
    var open=e.target.closest('[data-open]');
    if(open){e.preventDefault();openDrawer(open.dataset.open);return;}
    var close=e.target.closest('[data-close]');
    if(close){var drawer=close.closest('.cart-drawer,.search-drawer');if(drawer)closeDrawer(drawer);}
  });
  document.addEventListener('keydown',function(e){
    if(e.key==='Escape'){document.querySelectorAll('.cart-drawer.is-open,.search-drawer.is-open').forEach(closeDrawer);}
  });

  // Header search → open search drawer on focus (predictive)
  document.querySelectorAll('[data-predictive-input]').forEach(function(input){
    if(input.closest('.header-search')){
      input.addEventListener('focus',function(e){
        e.preventDefault();
        input.blur();
        openDrawer('SearchDrawer');
        setTimeout(function(){var d=document.querySelector('#SearchDrawer .search-drawer__input');if(d)d.focus();},250);
      });
    }
  });

  // Countdown
  document.querySelectorAll('[data-deals-end]').forEach(function(section){
    var hours=parseFloat(section.dataset.dealsEnd)||48;
    var end=Date.now()+hours*3600*1000;
    var el=section.querySelector('[data-countdown]');if(!el)return;
    var d=el.querySelector('[data-days]'),h=el.querySelector('[data-hours]'),m=el.querySelector('[data-mins]'),s=el.querySelector('[data-secs]');
    function tick(){
      var diff=Math.max(0,end-Date.now());
      var dd=Math.floor(diff/86400000);
      var hh=Math.floor(diff%86400000/3600000);
      var mm=Math.floor(diff%3600000/60000);
      var ss=Math.floor(diff%60000/1000);
      function pad(n){return n<10?'0'+n:n}
      d.textContent=pad(dd);h.textContent=pad(hh);m.textContent=pad(mm);s.textContent=pad(ss);
    }
    tick();setInterval(tick,1000);
  });

  // Animated counters
  function animateCounter(el){
    var target=parseInt(el.dataset.target,10)||0;
    var suffix=(el.textContent.match(/[^\d]+$/)||[''])[0];
    var dur=1600, start=performance.now();
    function frame(now){
      var p=Math.min(1,(now-start)/dur);
      var ease=1-Math.pow(1-p,3);
      el.textContent=Math.floor(target*ease).toLocaleString()+suffix;
      if(p<1)requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }
  var io=new IntersectionObserver(function(entries){
    entries.forEach(function(en){if(en.isIntersecting){animateCounter(en.target);io.unobserve(en.target);}});
  },{threshold:.4});
  document.querySelectorAll('[data-counter]').forEach(function(el){io.observe(el);});

  // Quantity stepper
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-qty]');if(!b)return;
    var input=b.parentElement.querySelector('input');
    var v=parseInt(input.value,10)||1;
    input.value=Math.max(1,b.dataset.qty==='+'?v+1:v-1);
  });

  // PDP thumb swap
  document.querySelectorAll('[data-thumb]').forEach(function(t){
    t.addEventListener('click',function(){
      var src=t.querySelector('img').src.replace('width=200','width=1200');
      var main=document.querySelector('.pdp__main-image img');if(main)main.src=src;
    });
  });

  // Cart count from Shopify
  if(window.fetch){
    fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
      document.querySelectorAll('[data-cart-count]').forEach(function(el){el.textContent=c.item_count;});
      document.querySelectorAll('[data-cart-subtotal]').forEach(function(el){el.textContent='$'+(c.total_price/100).toFixed(2);});
    }).catch(function(){});
  }

  // Quick add (real Shopify)
  document.addEventListener('click',function(e){
    var btn=e.target.closest('[data-action="quick-add"]');
    if(!btn||!btn.dataset.variantId)return;
    e.preventDefault();
    btn.disabled=true;var orig=btn.innerHTML;btn.innerHTML='Adding…';
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:btn.dataset.variantId,quantity:1})})
      .then(function(r){return r.json();})
      .then(function(){btn.innerHTML='✓ Added';openDrawer('CartDrawer');setTimeout(function(){btn.innerHTML=orig;btn.disabled=false;},1200);})
      .catch(function(){btn.innerHTML=orig;btn.disabled=false;});
  });
})();
